import { isIPhone } from 'shared/javascripts/util/detection'

export function scrollToTop(): void {
  document.scrollingElement!.scrollTo({ top: 0, behavior: isIPhone() ? 'auto' : 'smooth' })
}
